import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import io, { Socket } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { ToastService } from './toast.service';

@Injectable()
export class SocketService {
  socket: Socket;
  public connected: Observable<boolean>;
  public connectedSubject: BehaviorSubject<boolean>;
  public inSyncPage = false;
  inited = false;

  constructor(
    private toast: ToastService
  ) {
    this.connectedSubject = new BehaviorSubject<boolean>(true);
    this.connected = this.connectedSubject.asObservable();
  }

  public get connectedValue(): boolean {
    return this.connectedSubject.value;
  }

  connect(): void {
    this.socket = io(environment.socketUrl, {
      transports: ['websocket']
    });
    console.log(this.socket.connected);
    this.socket.on('connect_failed', async () => {
      console.log('connect_failed');
      this.connectedSubject.next(false);
    });
    this.socket.on('connect_error', async (err) => {
      console.log('connect_error');
      console.log(err);
      this.connectedSubject.next(false);
    });
    this.socket.on('connect', async () => {
      console.log('connected');
      this.connectedSubject.next(this.socket.connected);
      console.log(this.connectedValue);
    });
    this.socket.on('disconnect', () => {
      console.log('disconnected');
      this.connectedSubject.next(false);
    });
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.connectedSubject.next(false);
    }
  }

}
